import Datagrid from "../../../components/Datagrid";
import { useEffect, useState } from "react";
import { useAuth } from "../../../contexts/AuthContext";
import {
  EyeIcon,
  EllipsisVerticalIcon,
  CheckIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import OrderDetailsModal from "./OrderDetailsModal";
import { formatPhoneNumber } from "../../../globalFunctions/PhoneNumberFormatter";

export default function ProviderProductOrders() {
  const [orders, setOrders] = useState([]);
  const { currentUser } = useAuth();
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    const providerId = currentUser.id;

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/orders/provider/${providerId}/products`
    )
      .then((res) => res.json())
      .then(setOrders);
  }, []);

  const columns = [
    {
      key: "orderNumber",
      label: "Commande",
      width: "120px",
      format: (val) => `#${val || "—"}`,
    },

    {
      key: "orderDate",
      label: "Date",
      width: "180px",
      format: (val) => (val ? new Date(val).toLocaleString() : "—"),
    },

    // Nombre d'items
    {
      key: "items",
      label: "Articles vendus",
      width: "150px",
      render: (row) => (
        <span className="text-primary font-medium">
          {row.items?.length || 0} article(s)
        </span>
      ),
    },

    // Type de vente
    {
      key: "typeVente",
      label: "Type de vente",
      width: "150px",
      render: (row) => {
        const hasShipping = row.items.some((i) => i.hasShipping);
        return (
          <span className="text-primary">
            {hasShipping ? "Livraison" : "Vente directe"}
          </span>
        );
      },
    },
    {
      key: "providerSubTotalFinal",
      label: "Sous-total",
      width: "130px",
      format: (val) => (val !== undefined ? `${val.toFixed(2)} $` : "—"),
    },

    {
      key: "providerTotal",
      label: "Total",
      width: "130px",
      format: (val) => (val !== undefined ? `${val.toFixed(2)} $` : "—"),
    },

    {
      key: "buyerPhone",
      label: "Téléphone",
      width: "150px",
      format: (val) => formatPhoneNumber(val) || "—",
    },

    {
      key: "deliveryAddress",
      label: "Adresse",
      width: "250px",
      format: (val) => val || "—",
    },

    {
      key: "actions",
      label: "",
      width: "120px",
      render: (row) => (
        <div className="flex items-center gap-2">
          {/* Consulter */}
          <button
            onClick={() => setSelectedOrder(row)}
            className="btn btn-ghost btn-sm"
            title="Consulter"
          >
            <EyeIcon className="w-5 h-5 text-primary" />
          </button>

          {/* Placeholder future options */}
          <div className="dropdown dropdown-end hidden">
            <button tabIndex={0} className="btn btn-ghost btn-sm">
              <EllipsisVerticalIcon className="w-5 h-5 text-primary hidden" />
            </button>

            <ul
              tabIndex={0}
              className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-40"
            >
              <li className="hidden">
                <button>
                  <CheckIcon className="w-4 h-4" />
                  Valider
                </button>
              </li>

              <li className="hidden">
                <button>
                  <XMarkIcon className="w-4 h-4" />
                  Annuler
                </button>
              </li>
            </ul>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <Datagrid columns={columns} data={orders} />
      <OrderDetailsModal
        order={selectedOrder}
        onClose={() => setSelectedOrder(null)}
      />
    </div>
  );
}
